import React from 'react'
import {MenuLink} from '@src/modules/Layout/shared/MenuLink'
import {MAIL_ROUTES} from '../../constants'
import {useCurrentUser} from '@therms/react-modules'
import {Badge, Icon} from '@therms/atalaya'
import {IoMdMail} from 'react-icons/io'

function MailMenuLink() {
  const {userClientMetadata} = useCurrentUser()
  return (
    <MenuLink to={MAIL_ROUTES.__ROOT__}>
      <div className="space-x-xs flex w-full items-center">
        <Icon Icon={IoMdMail} />

        <span className="grow">Mail</span>

        {!!userClientMetadata.unread.mail && (
          <Badge value={userClientMetadata.unread.mail} variant="info" />
        )}
      </div>
    </MenuLink>
  )
}

export {MailMenuLink}
